module.exports = __webpack_public_path__ + "img/zhous.d75ffb50.jpg";